export enum RockLevelCode {
  user = '0000',
  companyAndDepartment = '0001',
  company = '0100',
  department = '0200',
}

export const RockLevelCodeDisplayMap: Partial<Record<RockLevelCode, string>> = {
  [RockLevelCode.user]: 'Team',
  [RockLevelCode.company]: 'Company',
  [RockLevelCode.department]: 'Department',
  [RockLevelCode.companyAndDepartment]: 'Company and Department',
};
